// キーワード検索 (q) を語に分ける。サーバー側 App\Helpers\Exa\SearchKeywordParser::parse() と同じ規則。
//
// 区切りは半角スペース・全角スペース (U+3000)・タブだけ。続いていれば 1 つとして扱う。
// 改行や引用符などそれ以外の文字は普通の文字としてそのまま残す。
// 同じ文字列の語は最初の 1 つだけ残す (順序は保つ)。正規化 (NFC 等) は掛けない。
// 重なりを除いた後の先頭 SEARCH_KEYWORD_MAX_TERMS 語だけを返す (33 語目以降は使わない。PHP の SearchKeywordParser::MAX_TERMS と同じ値。語の数に比例して検索の SQL が重くなるため)。
// PHP と JS で同じ結果になることは qa/contracts/search-keyword-terms.json を両方のテストが読んで確かめる。
export const SEARCH_KEYWORD_MAX_TERMS = 32;
const SEARCH_KEYWORD_SEPARATORS = /[ \t　]+/;

export const splitSearchKeywordTerms = (value) => {
  if (value === null || value === undefined) {
    return [];
  }
  const terms = String(value).split(SEARCH_KEYWORD_SEPARATORS).filter((term) => term !== '');
  return Array.from(new Set(terms)).slice(0, SEARCH_KEYWORD_MAX_TERMS);
};
